import React from "react";
import "./QBOPullCategoriesModal.scss";
import OwButton from "../../../shared/OwButton/OwButton";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import IQBOOnPullCategoriesDTO from "@models/DTO/IQBOOnPullCategoriesDTO";

type Props = {
    closeModalFn: () => void;
    startPullFn: () => void;
    isLoading?: boolean;
    results?: IQBOOnPullCategoriesDTO;
    error?: string;
};

export const QBOPullCategoriesModal: React.FC<Props> = (props) => {
    const closeModal = () => {
        props.closeModalFn();
    };

    const start = () => {
        props.startPullFn();
    };

    const renderContent = () => {
        // Loading state
        if (props.isLoading) {
            return (
                <div className="text-center py-4">
                    <i className="fad fa-spinner fa-spin fa-3x mb-3"></i>
                    <p className="mb-0">Pulling categories from QuickBooks Online...</p>
                </div>
            );
        }

        // Error state
        if (props.error) {
            return (
                <>
                    <div className="alert alert-danger">
                        <h5 className="mb-2">Error</h5>
                        <p className="mb-0">{props.error}</p>
                    </div>
                    <div className="mt-3">
                        <OwButton title={"close"} fn={closeModal} />
                    </div>
                </>
            );
        }

        // Results state
        if (props.results) {
            return (
                <>
                    <div className="alert alert-success">
                        <h5 className="mb-3">Categories Synced Successfully</h5>
                        <ul className="mb-0">
                            <li>
                                <strong>{props.results.totalCategoriesFetched}</strong> categories fetched from QuickBooks
                            </li>
                            <li>
                                <strong>{props.results.rootCategoriesCreated}</strong> root categories created
                            </li>
                            <li>
                                <strong>{props.results.subCategoriesCreated}</strong> sub-categories created
                            </li>
                            <li>
                                <strong>{props.results.orphanedCategoriesRemoved}</strong> orphaned categories removed
                            </li>
                        </ul>
                    </div>
                    <div className="mt-3">
                        <OwButton title={"close"} fn={closeModal} />
                    </div>
                </>
            );
        }

        // Initial confirmation state
        return (
            <>
                <div className={"mt-3"}>
                    <p>This will pull categories from QuickBooks Online and sync them with your catalog.</p>
                </div>
                <div className="mt-3">
                    <OwButton title={"pull_categories"} fn={start} />
                </div>
            </>
        );
    };

    return (
        <div className={"QBOPullCategoriesModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <div>
                        <OwTitle leftIconName={"fad fa-cloud-download-alt"} title={"quickbooks_online"} tag={"h3"} />
                        <OwTitle title={"pull_categories"} tag={"h5"} />
                    </div>
                    {!props.isLoading && (
                        <div>
                            <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                        </div>
                    )}
                </div>
            </div>
            {renderContent()}
        </div>
    );
};
